import Layout from "@layouts/withoutNaviagtion/withoutNavigationLayout";
import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import DataTable from "@components/DataTable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import { adminDeleteSpecificOrganization } from "@services/client-list.service";
import Notfound from "@components/Not-Found";
import moment from "moment";
import Loader from "@components/common/Loader";
import FilterForm from "@components/common/AddFilter/FilterForm";
import {
	adminGetCountriesListManagement,
	adminGetLegislationManagement,
	adminGetLegislationManagementRule,
	adminGetListManagementStateCategoryList,
	adminGetStatesListManagement,
} from "@services/list-management.service";
import { UpdateBulkStatusCheckpointPEComplianceTask } from "@services/checkpoint.service";
import { useParams } from "react-router-dom";
import { formatText } from "@_common/format-text";
import TaskLicenseNavigation from "@components/Tasks/task-license-navigation";
import { getSpecificLicenseHistoryTask } from "@services/license.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import { NavLink } from "react-router-dom";
import ScrollableReactTable from "@components/ScrollableDatatable";

interface IComplianceTaskHistoryProps {}

const TaskLicenseHistory: React.FunctionComponent<
	IComplianceTaskHistoryProps
> = (props: any) => {
	let navigate = useNavigate();
	let mainParams = useParams();

	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */

	const [isLoading, setIsLoading] = React.useState(true);
	const [list, setList] = React.useState<[]>([]);
	const [isFilterVisible, setFilterVisibility] = React.useState(false);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */

	useEffect(() => {
		getCountriesList();
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
			getData();
			setDate(new Date());
		}
	}, [props.permissionAPITriggered]);

	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
			getData();
			if (params.page_no) {
				setPage_no(parseInt(params.page_no));
			}
			if (params.search_text) {
				setSearchInput(params.search_text);
				setShowSearchTextbox(true);
			}
			if (params.limit) {
				setLimit(parseInt(params.limit));
			}
			if (params.date) {
				setDate(new Date(params.date));
			} else {
				setDate(new Date());
			}
			setRequest({
				country_id: getValue(params, `country_id`, "101"),
				state_id: getValue(params, `state_id`, ""),
				category_of_law_id: getValue(params, `category_of_law_id`, ""),
				legislation_id: getValue(params, `legislation_id`, ""),
				legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
			});
			if (getValue(params, `country_id`, "")) {
				setFilterVisibility(true);
				getStatesList(getValue(params, `country_id`, ""));
			}
			if (getValue(params, `state_id`, "")) {
				getAlreadyAttachedData(getValue(params, `state_id`, ""));
				getLegislationList(getValue(params, `state_id`, ""));
			}
			if (getValue(params, `legislation_id`, "")) {
				getLegislationRuleList(getValue(params, `legislation_id`, ""));
			}
		}
	}, [window.location.href, props.permissionAPITriggered]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */
	const getData = async () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let dates = params.date ? new Date(params.date) : new Date();
		var firstDay = new Date(dates.getFullYear(), dates.getMonth(), 1);
		var lastDay = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
		let payload: any = {
			page_no: params.page_no ? parseInt(params.page_no) : 1,
			page_size: params.limit ? parseInt(params.limit) : limit,
			search_text: params.search_text,
			location_id: mainParams.locationId,
			checkpoint_id: mainParams.checkpoint_id,
			license_type_id: mainParams.license_type_id,
			// from_date: moment(firstDay).format("YYYY-MM-DD"),
			// to_date: moment(lastDay).format("YYYY-MM-DD"),
			// country_id: getValue(request, `country_id`, ""),
			// state_id: getValue(request, `state_id`, ""),
			// category_of_law_id: getValue(request, `category_of_law_id`, ""),
			// legislation_id: getValue(request, `legislation_id`, ""),
			// legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
			// compliance_type_id: getValue(props, `match.params.id`, ""),
		};
		let queryRequest = QueryRequestHelper(payload);
		try {
			setIsLoading(true);
			let resp = await getSpecificLicenseHistoryTask(
				mainParams.id,
				queryRequest
			);
			if (resp) {
				setList(
					getValue(resp, `data.task_history`, []).map((item: object) => ({
						...item,
						checkpoint_id: getValue(item, `compliance_task_id`, ""),
						frequency: getValue(item, `legal_due_date`, "")
							? moment(new Date(getValue(item, `legal_due_date`, ""))).format(
									"DD MMM YYYY"
							  )
							: "",
						rule: getValue(
							item,
							`pe_compliance.checkpoint.legislation_rule.rule_name`,
							""
						),
						compliance_activity: getValue(
							item,
							`pe_compliance.checkpoint.compliance_activity`,
							""
						),
						completion_date: getValue(item, `completion_date`, "")
							? moment(getValue(item, `completion_date`, "")).format(
									"DD MMM YYYY"
							  )
							: "",
						follow_up_date: getValue(item, `follow_up_date`, "")
							? moment(getValue(item, `follow_up_date`, "")).format(
									"DD MMM YYYY"
							  )
							: "",

						status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
						updated_by:
							getValue(item, `updated_by.first_name`, "") +
							" " +
							getValue(item, `updated_by.last_name`, ""),
						industry: getValue(item, `industry.text`, ""),
						business_type: getValue(item, `business_type.text`, ""),
						location: getValue(
							item,
							`pe_compliance.location.location_name`,
							""
						),
						work_status: formatText(getValue(item, `work_status`, "")),
						license_status: formatText(getValue(item, `license_status`, "")),
						function: getValue(
							item,
							`pe_compliance.function.function_name`,
							""
						),
					}))
				);
				setTotalCount(getValue(resp, `data.pagination.total`, 0));
				setIsLoading(false);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Search section                               */
	/* -------------------------------------------------------------------------- */
	const [showSearchTextbox, setShowSearchTextbox] = useState(false);
	const [search_text, setSearchInput] = useState<any>("");

	const toggleSearch = () => {
		setShowSearchTextbox((prevState) => !prevState);
	};
	const toggleSearchClose = () => {
		setSearchInput("");
		toggleSearch();
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		if (params.search_text) {
			delete params.search_text;
			let payload: any = { ...params };
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
			getData();
		}
	};

	const handleChangeSearch = async (e: any) => {
		setSearchInput(e.target.value);
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
		  ...params,
		  page_no: 1,
		  search_text: e.target.value,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
		if (!e.target.value) {
			getData();
		}
	};

	const [selectedIDs, setSelectedIDs] = useState<any>([]);
	const getTableState = (value: object) => {
		let selectedIndexList = Object.keys(
			getValue(value, `selectedRowIds`, {})
		).map((item) => parseInt(item));
		let selectedIds =
			list.length > 0
				? list.filter((_item: object, index: number) =>
						selectedIndexList.includes(index)
				  )
				: [];
		if (selectedIds.length > 0) {
			setSelectedIDs(
				selectedIds.map((item: object) => getValue(item, `id`, ""))
			);
		} else {
			setSelectedIDs([]);
		}
	};

	/* -------------------------------------------------------------------------- */
	/*                                 Delete section                             */
	/* -------------------------------------------------------------------------- */

	const [deleteValue, setDeleteValue] = useState("");
	const [deleteId, setDeleteId] = useState("");
	const handleDeleteFun = (id: string, value: string) => {
		setDeleteValue(value);
		setDeleteId(id);
		handleDelete();
	};
	const [isDelete, setIsDelete] = useState(false);
	const handleDelete = () => {
		setIsDelete(!isDelete);
	};

	const handleDeleteFunction = async () => {
		try {
			let resp = await adminDeleteSpecificOrganization(deleteId);
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				handleDelete();
				getData();
			}
		} catch (error) {}
	};

	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleChangeSortBy = (value: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		params.sort_by = value;
		props.history.push({
			pathname: window.location.pathname,
			query: params,
		});
	};

	const handleChangeStatus = (value: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		params.status = value;
		props.history.push({
			pathname: window.location.pathname,
			query: params,
		});
	};
	/* -------------------------------------------------------------------------- */
	/*                               Pagination section                           */
	/* -------------------------------------------------------------------------- */

	const [totalCount, setTotalCount] = useState(0);
	const [limit, setLimit] = useState(10);
	const [page_no, setPage_no] = useState(1);

	const handleChangePagination = (page_no: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload = {
			...params,
			page_no: page_no,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleChangeLimit = (limit: string) => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload:any = {
			...params,
			limit:limit,
			page_no:'1'
		}
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};

	const handleEdit = (id: string) => {
		navigate(`/configuration/vendors/add/${id}`);
	};
	const rowClick = (obj: object) => {
		navigate(
			`/activities/task/license/list/detail/${getValue(obj, `original.id`, "")}/${getValue(
				obj,
				`original.license.checkpoint.id`,
				""
			)}/${getValue(obj, `original.license.location.id`, "")}/${getValue(
				obj,
				`original.license.license_type.id`,
				""
			)}`
		);
	};

	// id={mainParams.id}
	// 					checkpoint_id={mainParams.checkpoint_id}
	// 					locationId={mainParams.locationId}
	// 					license_type_id={mainParams.license_type_id}
	const getTrProps = (rowInfo: any) => {
		if (getValue(rowInfo, `id`, "")) {
			return {
				style: {
					//   background:  'red',
					//   color: 'black'
				},
			};
		}
		return {};
	};
	const columns = React.useMemo(
		() => [
			{
				Header: "Activity ID",
				accessor: "license_task_id",
				width: 200,
				Cell: ({ row }: any) => {
					return (
						<NavLink
							to={`/activities/task/license/list/detail/${row.original.id}/${getValue(
								row,
								`original.license.checkpoint.id`,
								""
							)}/${getValue(
								row,
								`original.license.location.id`,
								""
							)}/${getValue(row, `original.license.license_type.id`, "")}`}
						>
							<>{row.values.license_task_id}</>
						</NavLink>
					);
				},
			},
			{
				Header: "Renewal Date",
				accessor: "renewal_reminder_date",
				width: 300,
			},
			{
				Header: "Work Status",
				accessor: "work_status",
				width: 200,
			},
			{
				Header: "Completed By",
				accessor: "updated_by",
				width: 200,
			},
			{
				Header: "Completed On",
				accessor: "completion_date",
				width: 200,
			},
			{
				Header: "Remarks",
				accessor: "remarks",
				width: 200,
			},
			{
				Header: "Reason for Non-Compliance",
				accessor: "non_compliance_reason",
				width: 200,
			},
			{
				Header: "Task Status",
				accessor: "compliance_status",
				width: 200,
			},
			{
				Header: "Task Status",
				accessor: "status",
				width: 200,
			},
			{
				Header: "License Status",
				accessor: "license_status",
				width: 200,
			},
			// 		 {
			//   	Header: "Action",
			//   	width: 170,
			//   	Cell: ({ row }: any) => {
			//   		return (
			//   			<>
			//   				<Button
			//   					color="primary"
			//   					onClick={() => handleEdit(row.original.id)}
			//   				>
			//   					Edit
			//   				</Button>
			//   			</>
			//   		);
			//   	},
			//   },
		],
		[]
	);

	const handleChangeActiveStatus = async (value: string) => {
		try {
			let resp = await UpdateBulkStatusCheckpointPEComplianceTask({
				ids: selectedIDs,
				is_active: value === "active" ? true : false,
			});
			if (resp) {
				toast.success(getValue(resp, `message`, ""));
				setSelectedIDs([]);
				getData();
			} else {
				getData();
			}
		} catch (error) {}
	};

	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	const [check, setCheck] = useState(false);
	const handleRemoveNavItems = () => {
		setCheck(!check);
		setSelectedIDs([]);
	};

	/* -------------------------------------------------------------------------- */
	/*                                  Smart Filters                             */
	/* -------------------------------------------------------------------------- */
	const [request, setRequest] = useState<any>({
		country_id: "101",
		state_id: "",
		category_of_law_id: "",
		legislation_id: "",
		legislation_rule_id: "",
	});
	useEffect(() => {
		getStatesList(request.country_id);
	}, [request.country_id]);

	const [countryList, setCountryList] = useState([]);
	const [states, setStates] = useState([]);

	const [categoryOfLawList, setCategoryOfLawList] = useState([]);
	const [legislationList, setLegislationList] = useState([]);
	const [ruleList, setRuleList] = useState([]);

	const reset = () => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		let payload: any = {
			page_no: params.page_no,
			search_text: getValue(params, `search_text`, ""),
			limit: getValue(params, `limit`, ""),
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
		getData();
		reset1();
	};
	const reset1 = () => {
		setRequest({
			...request,
			// country_id: "",
			state_id: "",
			category_of_law_id: "",
			legislation_id: "",
			legislation_rule_id: "",
		});
	};

	const getCountriesList = async () => {
		try {
			let resp = await adminGetCountriesListManagement();
			if (resp) {
				setCountryList(
					getValue(resp, `data.countries`, []).map((item: object) => ({
						...item,
						value: getValue(item, `name`, ""),
						label: getValue(item, `name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getStatesList = async (countryId: number) => {
		if (countryId) {
			try {
				let resp = await adminGetStatesListManagement(countryId);
				if (resp) {
					setStates(
						getValue(resp, `data.states`, []).map((item: object) => ({
							...item,
							value: getValue(item, `name`, ""),
							label: getValue(item, `name`, ""),
						}))
					);
				} else {
				}
			} catch (error) {}
		}
	};

	const getAlreadyAttachedData = async (state_id: string) => {
		try {
			let resp = await adminGetListManagementStateCategoryList(state_id);
			if (resp) {
				setCategoryOfLawList(
					getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
						// ...item,
						id: getValue(item, `category_of_law.id`, ""),
						value: getValue(item, `category_of_law.text`, ""),
						label: getValue(item, `category_of_law.text`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const getLegislationList = async (stateId: string) => {
		try {
			let resp = await adminGetLegislationManagement(stateId);
			if (resp) {
				setLegislationList(
					getValue(resp, `data.legislations`, []).map((item: object) => ({
						...item,
						value: getValue(item, `legislation_name`, ""),
						label: getValue(item, `legislation_name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};
	const getLegislationRuleList = async (legislation_id: string) => {
		try {
			let resp = await adminGetLegislationManagementRule(legislation_id);
			if (resp) {
				setRuleList(
					getValue(resp, `data.legislationRules`, []).map((item: object) => ({
						...item,
						value: getValue(item, `rule_name`, ""),
						label: getValue(item, `rule_name`, ""),
					}))
				);
			} else {
			}
		} catch (error) {}
	};

	const handleChangeSelect = (e: any, type: string) => {
		if (type === "country_id") {
			getStatesList(e.id);
			setStates([]);
			setCategoryOfLawList([]);
			setLegislationList([]);
			setRuleList([]);
			setRequest({
				...request,
				country_id: e.id,
				state_id: "",
				category_of_law_id: "",
				legislation_id: "",
				legislation_rule_id: "",
			});
		}
		if (type === "state_id") {
			getAlreadyAttachedData(e.id);
			getLegislationList(e.id);
			setCategoryOfLawList([]);
			setLegislationList([]);
			setRuleList([]);
			setRequest({
				...request,
				state_id: e.id,
				category_of_law_id: "",
				legislation_id: "",
				legislation_rule_id: "",
			});
		}
		if (type === "category_of_law_id") {
			setRequest({
				...request,
				category_of_law_id: e.id,
			});
		}
		if (type === "legislation_id") {
			getLegislationRuleList(e.id);
			setRequest({
				...request,
				legislation_id: e.id,
				legislation_rule_id: "",
			});
		}

		if (type === "legislation_rule_id") {
			setRequest({
				...request,
				legislation_rule_id: e.id,
			});
		}
	};

	const handleSubmitSmartFilter = () => {
		if (
			getValue(request, `country_id`, "")
			// getValue(request, `state_id`, "")
			// && getValue(request, `category_of_law_id`, "") &&
			// getValue(request, `legislation_id`, "") &&
			// getValue(request, `legislation_rule_id`, "")
		) {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			let dates = params.date ? new Date(params.date) : new Date();
			var firstDay = new Date(dates.getFullYear(), dates.getMonth(), 1);
			var lastDay = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
			let payload: any = {
				...params,
				page_no: params.page_no ? parseInt(params.page_no) : 1,
				page_size: params.limit ? parseInt(params.limit) : limit,
				search_text: params.search_text,
				status: "active",
				sort_by: params.sort_by,
				from_date: moment(firstDay).format("YYYY-MM-DD"),
				to_date: moment(lastDay).format("YYYY-MM-DD"),
				country_id: getValue(request, `country_id`, ""),
				state_id: getValue(request, `state_id`, ""),
				category_of_law_id: getValue(request, `category_of_law_id`, ""),
				legislation_id: getValue(request, `legislation_id`, ""),
				legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
				compliance_type_id: getValue(props, `match.params.id`, ""),
			};
			let queryRequest = QueryRequestHelper(payload);
			navigate(`${window.location.pathname}?${queryRequest}`);
		} else {
			toast.error("All fields are mandatory");
		}
	};

	let country_ID = getValue(countryList,`length`,0)>0&&countryList.filter(
		(item: object) =>
			getValue(item, `id`, "") == getValue(request, `country_id`, "")
	);
	let state_ID = getValue(states,`length`,0)>0&&states.filter(
		(item: object) =>
			getValue(item, `id`, "") == getValue(request, `state_id`, "")
	);
	let cat_ID = getValue(categoryOfLawList,`length`,0)>0&&categoryOfLawList.filter(
		(item: object) =>
			getValue(item, `id`, "") == getValue(request, `category_of_law_id`, "")
	);
	let leg_ID = getValue(legislationList,`length`,0)>0&&legislationList.filter(
		(item: object) =>
			getValue(item, `id`, "") == getValue(request, `legislation_id`, "")
	);
	let rule_ID = getValue(ruleList,`length`,0)>0&&ruleList.filter(
		(item: object) =>
			getValue(item, `id`, "") == getValue(request, `legislation_rule_id`, "")
	);
	/* -------------------------------------------------------------------------- */
	/*                              Date Routes                                   */
	/* -------------------------------------------------------------------------- */
	const [date, setDate] = useState<Date | null>(null);
	const handleSubmitDate = () => {
		let dates = moment(date).format("YYYY-MM-DD");
		let payload: any = {
			date: dates,
		};
		let queryRequest = QueryRequestHelper(payload);
		navigate(`${window.location.pathname}?${queryRequest}`);
	};
	const [permissionLoading, setPermissionLoading] = useState(true);

	return (
		<Layout>
			{!isLoading &&
			!getValue(props, `subTabPermissionList`, []).includes("activities_licenses") ? (
				<NoAccessPage />
			) : (
				<>
					<TaskLicenseNavigation
						id={mainParams.id}
						checkpoint_id={mainParams.checkpoint_id}
						locationId={mainParams.locationId}
						license_type_id={mainParams.license_type_id}
					/>
					{/* {getValue(selectedIDs, `length`, 0) > 0 && (
				<NavigationBar
					selectedIDs={selectedIDs}
					isMarkInactiveSectionVisible={true}
					handleChangeActiveStatus={handleChangeActiveStatus}
					text={"MARK INACTIVE"}
					multi={true}
					handleRemoveNavItems={handleRemoveNavItems}
				/>
			)} */}
					<div className="admin-wrapper position-relative">
						<div className="admin-wrapper position-relative">
							<SearchHeader
								route={"/configuration/vendors/add"}
								searchInput={search_text}
								showSearchTextbox={showSearchTextbox}
								toggleSearch={toggleSearch}
								toggleSearchClose={toggleSearchClose}
								handleChangeSearch={handleChangeSearch}
								isBulkUploadVisible={false}
								smartFilter={false}
								setFilterFormVisibility={() => {
									setFilterVisibility(!isFilterVisible);
								}}
								isFilterVisible={isFilterVisible}
								add="false"
							/>
						</div>
						{isFilterVisible && (
							<FilterForm
								setFilterFormVisibility={() => {
									setFilterVisibility(!isFilterVisible);
								}}
								countryList={countryList}
								states={states}
								categoryOfLawList={categoryOfLawList}
								legislationList={legislationList}
								ruleList={ruleList}
								handleChangeSelect={handleChangeSelect}
								additionalFilter={false}
								country_ID={country_ID}
								state_ID={state_ID}
								cat_ID={cat_ID}
								leg_ID={leg_ID}
								rule_ID={rule_ID}
								reset={reset}
								handleSubmitSmartFilter={handleSubmitSmartFilter}
							/>
						)}
						{isLoading || !props.permissionAPITriggered ? (
							<Loader />
						) : list.length > 0 ? (
							<ScrollableReactTable
								columns={columns}
								data={list}
								getTableState={getTableState}
								rowClick={rowClick}
								check={check}
								selectedIDs={selectedIDs}
								getTrProps={getTrProps}
							/>
						) : (
							<>
								{Object.keys(params).length !== 0 ? (
									<>
										<Notfound />
									</>
								) : (
									<Notfound />
								)}
							</>
						)}
					</div>
					<div className="footer-wrapper d-flex justify-content-between">
						{list.length > 0 && (
							<img
								src="/images/building-illustration.svg"
								className="img-fluid"
							/>
						)}
						{totalCount > 10 ? (
							<PaginationPage
								totalCount={totalCount}
								limit={limit}
								pageNumber={page_no}
								handleChangePagination={handleChangePagination}
								handleChangeLimit={handleChangeLimit}
							/>
						) : (
							<p className="show-rows-count mt-3 d-flex">
								Total Count:&nbsp;&nbsp;{" "}
								<p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
							</p>
						)}
					</div>
					<DeleteModal
						isOpen={isDelete}
						handleModal={handleDelete}
						handleSubmit={handleDeleteFunction}
						deleteValue={deleteValue}
					/>
				</>
			)}
		</Layout>
	);
};

export default TaskLicenseHistory;
